import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const csrData = [
  {
    id: 1,
    img: "https://www.abulkhairgroup.com/wp-content/uploads/2020/11/01-1024x508-300x150-1.jpg",
    title:
      "ASSOCIATION WITH A NOBLE INITIATIVE AHSANIA MISSION CANCER HOSPITAL",
    desc: `Shah Cement contributed in the fund for establishing Ahsania Mission Cancer Hospital. According to the estimates of the Bangladesh Cancer Society there are currently more than 12,00,000 cancer patients in Bangladesh. About 200,000 new cancer patients are added each year.`,
  },
  {
    id: 2,
    img: "https://www.abulkhairgroup.com/wp-content/uploads/2020/11/re-300x100-1.jpg",
    title: "SHAH CEMENT FREE MEDICAL CONSULTANCY",
    desc: `Throughout the year, Shah Cement arranges free medical consultancy for those who don’t have the economic capabilities to avail medical facilities.`,
  },
  {
    id: 3,
    img: "https://www.abulkhairgroup.com/wp-content/uploads/2020/11/new-1024x596-300x150-1.jpg",
    title: "COW BRAND COLOUR COATED STEEL SPONSORED SCHOOL",
    desc: `In order to support a remotely located community Cow Brand Colour Coated Steel has re-constructed Proshikhon Tila Border Guard Primary School at Dighinala, Khagrachari.`,
  },
  {
    id: 4,
    img: "https://www.abulkhairgroup.com/wp-content/uploads/2020/11/DSC01859-1024x576-600x300-1.jpg",
    title: "ABUL KHAIR STEEL AND POWER LTD SUPPORTED SCHOOL",
    desc: `Abul Khair Steel and Power Ltd supported school in Madambibirhat, Sitakundu, Chittagong.`,
  },
  {
    id: 5,
    img: "https://www.abulkhairgroup.com/wp-content/uploads/2020/11/02-600x456-1.jpg",
    title: "SHAH CEMENT NIRMANER TAROKA",
    desc: `It remains a unique initiative to harness the creative talent of the unsung heroes of construction industry. Shah Cement organizes ‘Shah Cement Nirman er Taroka’ across the country celebrating the life of construction workers to recognize and encourage their versatile talent and their enthusiasm.`,
  },
];

const CSR = () => {
  return (
    <Wrapper>
      <section
        className="rs-breadcrumb-area rs-breadcrumb-one p-relative"
        style={{
          paddingTop: "45px",
          paddingBottom: "45px",
        }}
      >
        <div
          className="rs-breadcrumb-bg"
          style={{
            backgroundImage: "url(/assets/images/bg/breadcrumb-bg-01.png)",
          }}
        ></div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-6 col-xl-8 col-lg-8">
              <div className="rs-breadcrumb-content-wrapper">
                <div className="rs-breadcrumb-title-wrapper">
                  <h1 className="rs-breadcrumb-title fs-1">
                    Corporate Social Responsibility
                  </h1>
                </div>
                <div className="rs-breadcrumb-menu">
                  <nav>
                    <ul>
                      <li>
                        <span>
                          <Link to="/">Home</Link>
                        </span>
                      </li>
                      <li>
                        <span>CSR</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="rs-postbox-area section-space">
        <div className="container">
          {csrData.map((csr) => {
            return (
              <div key={csr.id} className="row align-items-start roww">
                <div className="col-md-4">
                  <div className="img-box">
                    <img src={csr.img} alt="Imge" />
                  </div>
                </div>

                <div className="col-md-8">
                  <h4 className="title">{csr.title}</h4>
                  <p>{csr.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .title {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 10px;
  }

  p {
    font-size: 16px;
    text-align: justify;
  }

  /* 🔥 Row spacing */
  .roww {
    margin-bottom: 50px;
  }

  /* Image styling */
  .img-box {
    width: 100%;
    height: 220px;
    overflow: hidden;
    border-radius: 8px;
  }

  .img-box img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  /* Medium screen */
  @media (max-width: 992px) {
    .roww {
      margin-bottom: 100px;
    }

    .col-md-4 {
      margin-bottom: 20px;
    }
  }

  /* Mobile */
  @media (max-width: 768px) {
    .roww {
      margin-bottom: 80px;
    }

    .img-box {
      height: 200px;
    }

    .col-md-4 {
      margin-bottom: 15px;
    }
  }

  /* Small mobile */
  @media (max-width: 480px) {
    .img-box {
      height: 180px;
    }
  }
`;

export default CSR;
